// The sign-in page. Connect a Solana wallet (a new wallet then picks a
// username), or use the username-and-password form: a free name makes the
// account; a taken one signs in when the password matches. Password sign-in is
// going away, so with wallet sign-in on the page says so. Behind it all, the
// live cube (logincube.js).

import { startLoginCube } from "./logincube.js";
import { NO_WALLET_APP, onNoWalletApp, signInWith, startWallets, walletError, walletPicker } from "./wallet.js";

const $ = id => document.getElementById(id);
const form = $("form"), nameForm = $("nameForm"), msg = $("msg");

// the live cube, blurred behind the form
startLoginCube($("cubeBg"), $("liveCube"));

function show(text, ok) {
  msg.hidden = !text;
  msg.textContent = text || "";
  msg.className = "msg " + (ok ? "ok" : "err");
}

// ---------- the human check (Turnstile), rendered into whichever form needs it ----------
let siteKey = null, tsLoad = null;
const widgets = new Map();
function loadTurnstile() {
  if (!tsLoad) tsLoad = new Promise(ok => {
    window.onTurnstileLoad = ok;
    const s = document.createElement("script");
    s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit&onload=onTurnstileLoad";
    s.async = true;
    document.head.append(s);
  });
  return tsLoad;
}
/** Puts the check in a form when the server has it switched on. It runs out of sight and only shows itself when Cloudflare wants a click. */
async function captchaIn(f) {
  if (!siteKey || widgets.has(f)) return;
  const box = document.createElement("div");
  box.className = "cf-turnstile";
  f.insertBefore(box, f.querySelector("button"));
  widgets.set(f, null);
  await loadTurnstile();
  widgets.set(f, window.turnstile.render(box, { sitekey: siteKey, appearance: "interaction-only", theme: "auto" }));
}
/** Turnstile's token for a form, waiting up to 10 s for a check still running out of sight; empty without Turnstile. */
async function captchaToken(f) {
  if (!widgets.has(f)) return "";
  for (let i = 0; i < 40; i++) {
    const t = f.elements["cf-turnstile-response"]?.value;
    if (t) return t;
    await new Promise(ok => setTimeout(ok, 250));
  }
  return "";
}
function captchaReset(f) { const id = widgets.get(f); if (id != null && window.turnstile) window.turnstile.reset(id); }

const post = (path, body) => fetch(path, {
  method: "POST", headers: { "Content-Type": "application/json" }, credentials: "same-origin", body: JSON.stringify(body)
}).then(r => r.json()).catch(() => ({ ok: false, message: "Couldn't reach the server. Try again." }));

const params = new URLSearchParams(location.search);
if (params.get("error")) show(params.get("error"), false);
const ref = (params.get("ref") || "").trim();
form.ref.value = ref;

fetch(`/api/invite?ref=${encodeURIComponent(ref)}`).then(r => r.json()).then(r => {
  siteKey = r.captcha || null;
  void captchaIn(form);
  if (r.from) $("intro").textContent = `${r.from} invited you to Cube 171: one shared Cube everyone digs at once.`;
  if (r.wallet) { $("walletBox").hidden = false; $("pwWarn").hidden = false; onNoWalletApp(() => show(NO_WALLET_APP, false)); startWallets(); }
  else form.username.focus();
}).catch(() => {});

// ---------- username and password ----------
form.addEventListener("submit", async e => {
  e.preventDefault();
  const b = form.querySelector("button");
  b.disabled = true;
  show("");
  const captcha = await captchaToken(form);
  const data = Object.fromEntries(new FormData(form));
  const r = await post("/api/play", { username: data.username.trim(), password: data.password, ref: data.ref, captcha });
  if (r.ok) { location.href = r.joined ? "/?welcome=1" : "/"; return; }
  b.disabled = false;
  show(r.message, false);
  captchaReset(form);
});

// ---------- a wallet ----------
let stopPicker = null, ticket = null, busy = false;
function pickerOpen(open) {
  $("walletList").hidden = !open;
  $("walletBtn").hidden = open;
  if (open && !stopPicker) stopPicker = walletPicker($("walletList"), useWallet);
}
$("walletBtn").addEventListener("click", () => pickerOpen(true));

async function useWallet(wallet) {
  if (busy) return;
  busy = true;
  show("Check your wallet to sign in…", true);
  try {
    const start = await post("/api/wallet/start", {});
    if (!start.ok) throw new Error(start.message || "the server couldn't start a sign-in");
    let signed;
    try { signed = await signInWith(wallet, start.input); }
    catch (e) { show(walletError(e), false); return; }
    const r = await post("/api/wallet/finish", { nonce: start.input.nonce, ...signed });
    if (r.ok) { location.href = "/"; return; }
    if (r.need === "username") {
      // a new wallet: choose a name, with the human check
      ticket = r.ticket;
      show("");
      $("nameIntro").textContent = `Wallet ${r.address.slice(0, 4)}…${r.address.slice(-4)} is new here. Choose a username to start playing.`;
      $("walletList").hidden = true;
      for (const id of ["form", "pwNote", "pwWarn", "orLine", "walletNote"]) $(id).hidden = true;
      nameForm.hidden = false;
      void captchaIn(nameForm);
      nameForm.username.focus();
      return;
    }
    show(r.message || "Couldn't sign in with that wallet.", false);
  } catch (e) {
    show(`Couldn't sign in: ${e.message}`, false);
  } finally {
    busy = false;
  }
}

nameForm.addEventListener("submit", async e => {
  e.preventDefault();
  const b = nameForm.querySelector("button[type=submit]");
  b.disabled = true;
  show("");
  const captcha = await captchaToken(nameForm);
  const r = await post("/api/wallet/join", { ticket, username: nameForm.username.value.trim(), captcha, ref });
  if (r.ok) { location.href = "/?welcome=1"; return; }
  b.disabled = false;
  show(r.message, false);
  captchaReset(nameForm);
  if (/again/.test(r.message || "") && /wallet/i.test(r.message || "")) $("nameBack").click();
});
$("nameBack").addEventListener("click", () => {
  ticket = null;
  nameForm.hidden = true;
  for (const id of ["form", "pwNote", "pwWarn", "orLine", "walletNote"]) $(id).hidden = false;
  pickerOpen(true);
  show("");
});
